import AnalyticsActions from '../actions/AnalyticsActions';

const initialState = {
  projectStats: {},
  projectDailyStats: {},
  gameStats: {},
  orgStats: {},
  loading: false,
  error: null,
  dateRange: {
    from: null,
    to: null,
    preset: '30days'
  }
};


// Helper function to process analytics response
const processAnalyticsResponse = (response) => {
  console.log('📊 Processing analytics response:', response);
  
  
  return {
    analyticsData: response,
    isValid: Array.isArray(response),
  };
};

const analyticsReducer = (store = initialState, action) => {
  const {payload} = action;

  switch (action.type) {
    case AnalyticsActions.GET_PROJECT_STATS.PENDING:
      return {
        ...store,
        loading: true,
        error: null
      };

    case AnalyticsActions.GET_PROJECT_STATS.FULFILLED: {
      console.log('🔍 AnalyticsReducer: GET_PROJECT_STATS.FULFILLED received');
      console.log('🔍 payload:', payload);
      console.log('storing action', action)

      // Not maybe the best way to get the projectId
      const projectId = action.payload?.config?.params?.projectId;
      
      const processed = processAnalyticsResponse(payload.data);
      
      if (processed.isValid) {
        console.log('🔍 Storing data for projectId:', projectId);
        console.log('🔍 Sotring Processed analytics data:', processed.analyticsData);
        
        return {
          ...store,
          loading: false,
          projectStats: {
            ...store.projectStats,
            [projectId]: processed.analyticsData
          },
          error: null
        };
      }
      
      console.error('🚨 Invalid response structure:', payload.data);
      return {
        ...store,
        loading: false,
        error: 'Invalid response structure from analytics API'
      };
    }

    case AnalyticsActions.GET_PROJECT_STATS.REJECTED: {
      // Check if this is a 403 Forbidden error
      const is403Error = payload.response?.status === 403;
      const errorMessage = is403Error 
        ? 'You do not have access to analytics for this project. Please contact info@dized.com to request access.'
        : payload.message || 'Failed to load analytics data';
      
      return {
        ...store,
        loading: false,
        error: errorMessage
      };
    }

    case AnalyticsActions.GET_PROJECT_DAILY_STATS.PENDING:
      return {
        ...store,
        loading: true,
        error: null
      };

    case AnalyticsActions.GET_PROJECT_DAILY_STATS.FULFILLED: {
      console.log('📅 AnalyticsReducer: GET_PROJECT_DAILY_STATS.FULFILLED received');
      console.log('📅 payload:', payload);

      const projectId = action.payload?.config?.params?.projectId;
      
      if (payload.data && Array.isArray(payload.data)) {
        console.log('📅 Storing daily stats data for projectId:', projectId);
        
        return {
          ...store,
          projectDailyStats: {
            ...store.projectDailyStats,
            [projectId]: payload.data
          },
          loading: false,
          error: null
        };
      }
      
      console.error('🚨 Invalid daily stats response structure:', payload.data);
      return {
        ...store,
        loading: false,
        error: 'Invalid response structure from daily stats API'
      };
    }

    case AnalyticsActions.GET_PROJECT_DAILY_STATS.REJECTED: {
      const is403Error = payload.response?.status === 403;
      const errorMessage = is403Error 
        ? 'You do not have access to daily analytics for this project. Please contact info@dized.com to request access.'
        : payload.message || 'Failed to load daily analytics data';
      
      return {
        ...store,
        loading: false,
        error: errorMessage
      };
    }

    default:
      // Log all actions to see what's being dispatched
      if (action.type && action.type.includes('AnalyticsActions')) {
        console.log('🔍 AnalyticsReducer received action:', action.type, action.payload);
      }
      return store;
  }
};

export default analyticsReducer;
